import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const jfrogArtifactory = defineConnector({
  identifier: "jfrogArtifactory",
  name: "JFrog Artifactory",
  tagLine: "Universal artifact repository",
  keywords: "binary repository packages registry maven docker helm",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a JFrog access token",
      items: [
        {
          kind: "markdown",
          content:
            "Generate an access token in the JFrog platform with the Artifactory permissions you need.",
        },
      ],
    },
    {
      title: "Enter your Artifactory details",
      items: [
        {
          kind: "baseUrl",
          label: "Artifactory base URL",
          required: true,
          placeholder: "https://company.jfrog.io",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/artifactory/api/system/ping`,
  },
});
